import Vue from "vue";
import Portfolio from "./Portfolio.vue";
import Dostepnosc from "./Dostepnosc.vue";
import Cookie from "./Cookie.vue";
import Mapa from "./Mapa.vue";
import store from "./store/store";

new Vue({
  el: "#app",
  store: store,
  render: h => h(Portfolio)
});

new Vue({
  el: "#app2",
  store: store,
  render: h => h(Dostepnosc)
});

new Vue({
  el: "#cookieInfo",
  render: h => h(Cookie)
});

new Vue({
  el: "#mapaGoogle",
  store: store,
  render: h => h(Mapa)
});



// WEBPACK FOOTER //
// ./src/main.js